<template>
    <div>
        <ViewInformation
            :data-create-quote="dataCreateQuote"
            :type="type" />
        <div v-show="step === 0">
            <div class="flex space-x-2 left justify-end items-center mt-5 gap-5">
                <hts-tooltip v-if="quoteData.alerts?.length">
                    <div>
                        <div
                            v-for="alert in quoteData.alerts"
                            :key="alert">
                            <p v-if="alert.label">
                                {{ alert.label }}
                            </p>

                            <div v-else>
                                <div v-if="alert.msgCode === 59">
                                    <p>
                                        Hệ thống không thể tính toán đầy đủ giá cho các trái tuyến sau do thiếu thông tin tuyến:
                                    </p>

                                    <p
                                        v-for="(label, index) in alert?.offLineRoutes || []"
                                        :key="index">
                                        - {{ Array.isArray(label) ? label.join(' >> ') : label }}
                                    </p>
                                </div>

                                <!--
                                  <div v-if="alert.msgCode === 61">
                                  <p>
                                  Thông tin tuyến chưa được vẽ đầy đủ trên hệ thống. Vui lòng xác nhận nếu bạn muốn tiếp tục tính toán giá dựa trên thông tin từ Google Maps
                                  cho các trái tuyến sau:
                                  </p>

                                  <p
                                  v-for="(label, index) in alert.offLineRoutes"
                                  :key="index">
                                  - {{ Array.isArray(label) ? label.join(' >> ') : label }}
                                  </p>
                                  </div>

                                  <div v-if="alert.msgCode === 62">
                                  <p>
                                  Thông tin tuyến chưa được vẽ đầy đủ trên hệ thống. Vui lòng xác nhận nếu bạn muốn tiếp tục tính toán giá dựa trên thông tin từ Google Maps
                                  cho tuyến
                                  {{ Array.isArray(alert.route) ? alert.route.join(' >> ') : alert.route }}
                                  <span v-if="alert.offLineRoutes?.length">
                                  và các trái tuyến sau:
                                  </span>
                                  </p>

                                  <p
                                  v-for="(label, index) in alert.offLineRoutes"
                                  :key="index">
                                  - {{ Array.isArray(label) ? label.join(' >> ') : label }}
                                  </p>
                                  </div>
                                -->
                            </div>
                        </div>
                    </div>
                    <template #reference>
                        <hi-exclamation-triangle-icon class="flex items-center text-warning-500 w-8 h-8" />
                    </template>
                </hts-tooltip>

                <hts-form-button
                    icon-name="hi-plus-circle-icon"
                    class="text-right"
                    color="info"
                    :btn-outline="false"
                    type="button"
                    @click="handleRequestPrice">
                    {{ $t('labels.requestPrice') }}
                </hts-form-button>
            </div>

            <hts-data-table
                ref="dataTables"
                class="mt-5"
                :first-data-rerender="firstDataRerenderDataTable"
                :headers="quotePriceHeaders"
                :items="quoteData.prices"
                :is-cell-clicked="false"
                :pagination="false"
                :is-footer="false"
                @selection-changed="selectionChanged" />
        </div>

        <div
            v-show="step === 1"
            class="mt-5">
            <div class="w-4/12 rounded-lg shadow-md relative">
                <div class="flex flex-col shadow-md space-x-1">
                    <div class="flex bg-blue-600 p-2 rounded-t-lg items-center">
                        <span class="text-white font-bold w-1/2">
                            {{ $t('labels.priceRequest') }}
                        </span>

                        <div class="flex items-center">
                            <hts-form-input
                                v-model="dataCreateQuote.informationEditorPricingSelling.tempPricingRequest"
                                :min="1"
                                required
                                type="number"
                                readonly
                                prop="tempPricingRequest"
                                name="tempPricingRequest" />
                            <hi-pencil-square-icon
                                class="h-5 w-5 ml-3 text-error-600 hover:text-error-500 cursor-pointer"
                                @click="openEditPricingInformation" />
                        </div>
                    </div>
                    <div class="flex p-2 items-center">
                        <span class="w-1/2">
                            {{ $t('labels.commission') }}<span class="text-error-500 ml-1">
                                *
                            </span>
                        </span>
                        <hts-form-input
                            v-model="dataCreateQuote.informationEditorPricingSelling.commission"
                            class="w-1/2"
                            :min="1"
                            required
                            readonly
                            type="number"
                            prop="commission"
                            name="commission" />
                    </div>
                    <div class="flex rounded-b-lg p-2 items-center">
                        <span class="w-1/2">
                            {{ $t('labels.timeDebt') }}<span class="text-error-500 ml-1">
                                *
                            </span>
                        </span>
                        <hts-form-input
                            v-model="dataCreateQuote.informationEditorPricingSelling.duration"
                            class="w-1/2"
                            :min="1"
                            required
                            readonly
                            type="number"
                            prop="duration"
                            name="duration">
                            <template #suffix>
                                {{ $t('labels.date') }}
                            </template>
                        </hts-form-input>
                    </div>
                </div>
            </div>
            <hts-data-table
                ref="dataTablesStep1"
                class="table-step-1"
                :headers="quotePriceHeadersStep1"
                :single-click-edit="true"
                :items="dataPositionsPricing"
                row-selection="single"
                :suppress-row-click-selection="true"
                :is-cell-clicked="false"
                :pagination="false"
                :is-footer="false"
                @selection-changed="selectionChangedStep1" />
            <hts-modal
                :show="showPopupEditPricingInformation"
                @close="showPopupEditPricingInformation = false">
                <template #custom>
                    <hts-form
                        :rules="{ priceRequest: 'required', commission: 'required', timeDebt: 'required' }"
                        class="space-y-6"
                        @submit="handleSubmitEditPricingInformation">
                        <hts-form-input
                            v-model="dataEditModelPricingInformation.tempPricingRequest"
                            :label="$t('labels.priceRequest')"
                            :min="1"
                            required
                            type="number"
                            prop="priceRequest"
                            name="priceRequest" />
                        <hts-form-input
                            v-model="dataEditModelPricingInformation.commission"
                            :label="$t('labels.commission')"
                            :min="1"
                            required
                            type="number"
                            prop="commission"
                            name="commission" />
                        <hts-form-input
                            v-model="dataEditModelPricingInformation.duration"
                            :label="$t('labels.timeDebt')"
                            :min="1"
                            required
                            type="number"
                            prop="timeDebt"
                            name="timeDebt">
                            <template #suffix>
                                {{ $t('labels.date') }}
                            </template>
                        </hts-form-input>
                        <div class="flex mt-5 justify-end">
                            <hts-form-button
                                icon-name="hi-check-icon"
                                icon-position="right"
                                color="primary"
                                type="submit"
                                :loading="false">
                                {{ $t('labels.save') }}
                            </hts-form-button>

                            <hts-form-button
                                class="pl-2"
                                icon-name="hi-x-mark-icon"
                                icon-position="right"
                                color="error"
                                @click="showPopupEditPricingInformation = false">
                                {{ $t('labels.cancel') }}
                            </hts-form-button>
                        </div>
                    </hts-form>
                </template>
            </hts-modal>
        </div>
        <div v-if="step === 2">
            <view-quote-price :data-create-quote="dataCreateQuote" />
        </div>
        <view-price-detail ref="viewPriceDetail" />
        <!-- <view-price-vendor ref="viewPriceVendor" /> -->
        <hts-modal
            :show="showPopupRequestPrice"
            :title="$t('labels.requestPrice')"
            type="confirm"
            :content="type === 'create' ? $t('labels.confirmRequestPrice') : $t('labels.confirmRequestPriceQuote')"
            @hide="showPopupRequestPrice = false"
            @confirm="confirmRequestPrice" />
        <hts-modal
            :show="showPopupWarningUnselectPricing"
            :content="contentWarningUnselectPricing"
            @hide="showPopupWarningUnselectPricing = false" />
        <view-offline-fee
            ref="viewOfflineFee"
            v-model:selection-price-offline-fee="selectionPriceOfflineFee"
            :price-offline-fee="type === 'create' ? quoteData.priceOfflineFee : dataEditQuote.oldPriceOfflineFee"
            edited
            :type="type" />
        <hts-modal
            :show="showOutOfflineFee"
            type="confirm"
            :content="$t('labels.confirmOutOfflineFee')"
            @hide="showOutOfflineFee = false"
            @confirm="confirmOutOfflineFee" />

        <hts-modal :show="showCostingErrors">
            <p class="mt-5">
                Hệ thống không thể thực hiện tính toán giá nội bộ, vui lòng nhập đầy đủ chi phí tùy biến cho
                <span class="text-bold font-bold">
                    {{ quoteData.costingErrors?.text || '' }}
                </span>
            </p>

            <div class="flex justify-end mt-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="button"
                    @click="showCostingErrors = false">
                    {{ $t('labels.confirm') }}
                </hts-form-button>
            </div>
        </hts-modal>

        <hts-modal :show="showPriceSystemError">
            <p
                v-if="showPriceSystemError"
                class="mt-5">
                {{ quoteData.priceSystemError?.alert ? quoteData.priceSystemError.text : $t('labels.messagePriceSystemError') }}
            </p>

            <div class="flex justify-end mt-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="button"
                    @click="showPriceSystemError = false">
                    {{ $t('labels.confirm') }}
                </hts-form-button>
            </div>
        </hts-modal>

    <!-- quoteData.costingErrors: {{ quoteData.costingErrors }} {{ !!quoteData.costingErrors }} -->
    </div>

    <hts-modal
        :show="showConfirmWarningMarkup"
        :title="$t('labels.confirmMarkup')"
        type="confirm"
        :content="contentConfirmMarkup"
        @hide="showConfirmWarningMarkup = false"
        @confirm="handelConfirmWarningMarkup" />

    <hts-modal
        title="Cảnh báo"
        :show="modals.price.show"
        @close="modals.price.show = false">
        <p v-if="modals.price.label">
            {{ modals.price.label }}
        </p>
        <div v-else>
            <div v-if="modals.price.msgCode === 59">
                <p>
                    Hệ thống không thể tính toán đầy đủ giá cho các trái tuyến sau do thiếu thông tin tuyến:
                </p>

                <p
                    v-for="(label, index) in modals.price?.offLineRoutes || []"
                    :key="index">
                    - {{ label }}
                </p>
            </div>
        </div>
    </hts-modal>

    <hts-modal
        title="Cảnh báo tuyến từ Map"
        :show="modals.priceRouteGGMap.show"
        type="confirm"
        :hide-close="true"
        :auto-close="true"
        @confirm="comfirmRouteGGMap"
        @hide="rejectRouteGGMap">
        <p v-if="modals.priceRouteGGMap.label">
            {{ modals.priceRouteGGMap.label }}
        </p>
        <div v-else>
            <div v-if="modals.priceRouteGGMap.msgCode === 61">
                <p>
                    Thông tin tuyến chưa được vẽ đầy đủ trên hệ thống. Vui lòng xác nhận nếu bạn muốn tiếp tục tính toán giá dựa trên thông tin từ Google Maps cho các
                    trái tuyến sau:
                </p>

                <p
                    v-for="(label, index) in modals.priceRouteGGMap?.offLineRoutes || []"
                    :key="index">
                    - {{ label }}
                </p>
            </div>

            <div v-if="modals.priceRouteGGMap.msgCode === 62">
                <p>
                    Thông tin tuyến chưa được vẽ đầy đủ trên hệ thống. Vui lòng xác nhận nếu bạn muốn tiếp tục tính toán giá dựa trên thông tin từ Google Maps cho tuyến
                    {{ modals.priceRouteGGMap.route }} <span v-if="modals.priceRouteGGMap.offLineRoutes?.length">
                        và các trái tuyến sau:
                    </span>
                </p>

                <p
                    v-for="(label, index) in modals.priceRouteGGMap?.offLineRoutes || []"
                    :key="index">
                    - {{ label }}
                </p>
            </div>
        </div>
    </hts-modal>
</template>

<script lang="ts" setup>
import { ICellEditorParams } from 'ag-grid-community'
import ceil from 'lodash-es/ceil'
import { nextTick, PropType } from 'vue'
import { addQuote } from './ignore/imports/form'
import ViewPriceDetail from './view-price-detail.vue'
// import ViewPriceVendor from './view-price-vendor.vue'
import ViewInformation from './information.vue'
import MarkupEdit from './markup-edit.vue'
import MarkupView from './markup-view.vue'
import ViewOfflineFee from './view-offline-fee.vue'
import ViewQuotePrice from './view-quote-price.vue'
import { $api, $lodash } from '#imports'
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '~/data/permissions/layout-permissions'
import actions from '~/pages/trucker-[id]/partner/-components/actions.vue'
import { numberFormatter } from '~/pages/trucker-[id]/price/vendor/ignore/data'
import { IQuote, ISearchPriceDetail } from '~/pages/trucker-[id]/quote/quote-request/-components/ignore/imports/form'
const { $formatters, $dayjs, $disableReactive } = useNuxtApp()

const props = defineProps({
  quoteData: {
    type: Object as PropType<IQuote>,
    required: true
  },
  dataEditQuote: {
    type: Object as PropType<addQuote>,
    default: () => {}
  },
  quoteRequestId: {
    type: String,
    default: ''
  },
  isDraft: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'create'
  },
  requestPrice: {
    type: Boolean
  },
  showRequestPrice: {
    type: Boolean,
    default: false
  },
  showModalAlert: {
    type: Boolean,
    default: false
  }
})
const { quoteData, quoteRequestId, isDraft, requestPrice, type, dataEditQuote, showModalAlert, showRequestPrice } = toRefs(props)

const emits = defineEmits(['requestPrice'])
const showConfirmWarningMarkup = ref(false)
const showPopupRequestPrice = ref(false)

const modals = ref({
  price: {
    show: false,
    label: '',
    msgCode: 0,
    route: [],
    offLineRoutes: [[]]
  },
  priceRouteGGMap: {
    show: false,
    label: '',
    msgCode: 0,
    route: [],
    offLineRoutes: [[]]
  }
})

const handleRequestPrice = () => {
  emits('requestPrice')
  if (showRequestPrice.value) {
    showPopupRequestPrice.value = true
  }
}

const showPopupWarningUnselectPricing = ref(false)
const contentWarningUnselectPricing = ref('')
const showCostingErrors = ref(false)
const showPriceSystemError = ref(false)

watch(
  () => quoteData.value,
  () => {
    !showModalAlert.value && _initData()
  },
  { deep: true }
)

const confirmRequestPrice = async () => {
  const api = $urlPartner.quote.quoteRequest.requestPrice
  const data: any = await $api(api, {
    uriParams: { ID: type.value === 'create' ? quoteRequestId.value : quoteData.value._id },
    body: { type: type.value === 'create' ? 'quote-request' : 'quote' }
  })
  const resData = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.requestPriceSuccess'))
    showPopupRequestPrice.value = false
  }
}

const dataCreateQuote = ref<addQuote>({
  informationEditorPricingSelling: {
    tempPricingRequest: null,
    pricingRequest: null,
    commission: null,
    duration: null,
    priceIncrementLevel: null
  },
  workflow: '',
  positions: [],
  transportation: '',
  mergeContainer: false,
  headContainer: false,
  priceOfflineFee: [],
  customerName: '',
  customer: '',
  contact: '',
  contactName: '',
  contactPhone: '',
  contactEmail: '',
  policy: {
    freeHourNumber: 0,
    moocKeepHourly: 0,
    moocKeepOvernight: 0,
    calculatedByHourNextDay: '',
    moocKeepLongTerm: 0,
    calculatedFromEvening: 0,
    towingContainerSunday: 0,
    towingContainerHoliday: 0,
    reeferPluginChargesGenerator: 0
  },
  customerService: {
    id: '',
    name: '',
    phone: ''
  },
  abstemious: {
    id: '',
    name: '',
    phone: ''
  },
  groupEmail: '',
  compensationCost: null,
  exceptCompensationCost: '',
  charges: [],
  cooperatorDetail: null,
  contactDetail: null,
  status: 0,
  quoteTempSaveId: '',
  effectiveFromDate: '',
  effectiveToDate: '',
  minMarkupConfirm: null,
  statusApprovalMarkup: null,
  markupAvailable: false,
  comfirmRouteGGMap: false
})

const viewPriceDetail = ref()
const viewPriceVendor = ref()

const handleViewQuotePrice = (item: ISearchPriceDetail) => {
  if (item.type === 'internal') {
    if (step.value === 0) {
      viewPriceDetail.value && viewPriceDetail.value.open(item, quoteData.value.priceOfflineFee)
    }
    if (step.value === 1) {
      viewPriceDetail.value && viewPriceDetail.value.open(item, dataCreateQuote.value.priceOfflineFee)
    }
  } else if (item.type === 'vendor') {
    viewPriceVendor?.value && viewPriceVendor.value.open(item.priceVendorId)
  }
}

const handleEditPositionDefault = (params: ICellEditorParams) => {
  const { dataConfig } = quoteData.value
  const pricingDetail = dataCreateQuote.value.informationEditorPricingSelling

  const markup: number = params?.data?.pricingEstimate?.markup || 0
  const profit = $lodash.ceil(params?.data?.pricingEstimate.total * (markup / 100), -2)
  const interestRate = params?.data?.pricingEstimate.total * (dataConfig.monthlyInterest / 100 / 30) * (pricingDetail.duration || 0)

  const selling =
    params?.data?.pricingEstimate.total * (1 + markup / 100) +
    interestRate +
    (pricingDetail.commission || 0) +
    (dataConfig.corporateIncomeTax / 100) * (pricingDetail.commission || 0)
  if (params?.data?.pricingEstimate) {
    params.data.pricingEstimate.markup = markupCalculate
    params.data.pricingEstimate.profit = profit
    params.data.pricingEstimate.selling = $lodash.round(selling)
    dataCreateQuote.value.informationEditorPricingSelling.tempPricingRequest = $disableReactive(params.data.pricingEstimate.selling)
  }
  markupCalculate(true)
}

const quotePriceHeadersStep1 = [
  {
    key: 'selection',
    suppressMenu: true,
    checkboxSelection: true,
    width: 50,
    maxWidth: 50
  },
  {
    field: 'fleetVehicle',
    headerName: $t('labels.fleetVehicle'),
    sortable: true,
    valueGetter: (params: any) => {
      return params.data.type === 'internal' ? $t('labels.internal') : params?.data?.vendorName
    }
  },
  {
    field: 'price',
    headerName: $t('labels.purchasePrice'),
    sortable: true,
    valueGetter: (params: any) => {
      return typeof params?.data?.pricingEstimate?.total === 'number' ? numberFormatter(params.data.pricingEstimate.total) : 0
    }
  },
  {
    field: 'markup',
    key: 'markup',
    headerName: $t('labels.markup'),
    editable: (params: any) => {
      return params.node.selected
    },
    autoHeight: true,
    cellEditor: MarkupEdit,
    cellRenderer: MarkupView,
    cellEditorParams: {
      handleEditMarkup: handleEditPositionDefault
    }
  },
  {
    field: 'profit',
    headerName: $t('labels.profit'),
    sortable: true,
    valueGetter: (params: any) => {
      const profit = params.data.pricingEstimate?.profit
      return typeof profit === 'number' ? numberFormatter($lodash.ceil(profit, -3)) : 0
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: actions,
    cellRendererParams: {
      notCheck: !isDraft.value,
      items: [
        {
          icon: 'hi-pencil-square-icon',
          label: $t('labels.viewDetail'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: true,
          validate: (data: { [key: string]: any }) => {
            if (data.type === 'internal') {
              return checkPermission(layoutPermissions.quote_view_detail_quote_internal)
            } else if (data.type === 'vendor') {
              return checkPermission(layoutPermissions.price_vendor_management)
            } else {
              return false
            }
          },
          click: handleViewQuotePrice
        }
      ]
    }
  }
]

const quotePriceHeaders = [
  {
    key: 'selection',
    suppressMenu: true,
    width: 50,
    maxWidth: 50,
    checkboxSelection: true
  },
  {
    field: 'fleetVehicle',
    headerName: $t('labels.fleetVehicle'),
    sortable: true,
    valueGetter: (params: any) => {
      return params.data.type === 'internal' ? $t('labels.internal') : params?.data?.vendorName
    }
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.createdAt)
    }
  },
  {
    field: 'route',
    headerName: $t('labels.route'),
    sortable: true,
    valueGetter: (params: any) => {
      if (params.data.positions && Array.isArray(params.data.positions)) {
        const pluckData = $lodash.map(params.data.positions, 'fullNameNode')

        return $lodash.join(pluckData, ' >> ')
      }
      return ''
    }
  },
  {
    field: 'quoteEqual',
    headerName: $t('labels.quoteEqual'),
    sortable: true,
    valueGetter: (params: any) => {
      return Array.isArray(params.data.positions) && getRouteName(params.data.positions, params.data)
    }
  },
  {
    field: 'price',
    headerName: $t('labels.purchasePrice'),
    sortable: true,
    valueGetter: (params: any) => {
      return typeof params?.data?.pricingEstimate?.total === 'number' ? numberFormatter(params.data.pricingEstimate.total) : 0
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: actions,
    cellRendererParams: {
      notCheck: !isDraft.value,
      items: [
        {
          icon: 'hi-pencil-square-icon',
          label: $t('labels.view'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: true,
          validate: (data: { [key: string]: any }) => {
            if (data.type === 'internal') {
              return checkPermission(layoutPermissions.quote_view_detail_quote_internal)
            } else if (data.type === 'vendor') {
              return checkPermission(layoutPermissions.price_vendor_management)
            } else {
              return false
            }
          },
          click: handleViewQuotePrice
        }
      ]
    }
  }
]

const getRouteName = (positions: Array<{ [key: string]: any }>, data: { [key: string]: any }, key: string = 'nodeTypeName') => {
  const result: Array<string> = []
  positions.forEach((position: { [key: string]: any }) => {
    if (data.type === 'internal') {
      result.push($t('labels.node'))
    } else if (position.quoteEqual === 'NODE') {
      result.push($t('labels.node'))
    } else if (position.quoteEqual === 'WARD') {
      result.push($t('labels.ward'))
    } else if (position.quoteEqual === 'DISTRICT') {
      result.push($t('labels.district'))
    } else if (position.quoteEqual === 'CITY') {
      result.push($t('labels.city'))
    }
  })
  return result.join(' >> ')
}
const dataPositionsPricing = ref<Array<ISearchPriceDetail>>()
const dataPositionsPricingSelection = ref<ISearchPriceDetail | null>()

const initDataPrePricing = () => {
  if (dataPositionsPricingSelection.value) {
    if (dataPositionsPricingSelection.value && dataPositionsPricingSelection.value?.pricingEstimate) {
      dataCreateQuote.value.informationEditorPricingSelling.tempPricingRequest = $disableReactive(
        dataPositionsPricingSelection.value?.pricingEstimate?.selling || 0
      )
      calculatedPriceIncrementLevel()
    }
  }
}

const calculatedPriceIncrementLevel = () => {
  const { dataConfig } = dataCreateQuote.value
  if (dataConfig) {
    const result = ((dataCreateQuote.value.informationEditorPricingSelling.tempPricingRequest || 0) * (1 + dataConfig.incrementLevel / 100)).toFixed(6)
    dataCreateQuote.value.informationEditorPricingSelling.priceIncrementLevel = ceil(Number(result), -4)
  }
}

const quoteId = computed(() => useRoute().params.idquote)

const dataPositionsPricingStep1 = ref<Array<ISearchPriceDetail>>()
const selectionChanged = (item: Array<ISearchPriceDetail> | []) => {
  if (type.value === 'edit') {
    const pluckIdSelect = $lodash.map(item, '_id')
    dataPositionsPricingStep1.value &&
      dataPositionsPricingStep1.value.map(async (itemSelectNode: ISearchPriceDetail) => {
        if (!pluckIdSelect.includes(itemSelectNode._id)) {
          if (await checkDataSelection(itemSelectNode)) {
            dataTables.value.gridApi.forEachNode((node: { [key: string]: any }) => {
              if (node?.data?._id === itemSelectNode._id) {
                node.setSelected(true)
              }
            })
          }
        }
      })
  }
  dataPositionsPricingStep1.value = $disableReactive(item)
}

const checkDataSelection = async (item: ISearchPriceDetail) => {
  const api = $urlPartner.quote.checkAllocationTrip

  const res = await $api(api, { uriParams: { ID: quoteId.value }, body: { ...item } })
  const resData: any = res?.data?.value
  if (resData?.success) {
    if (resData.data) {
      if (resData?.data?.unSelection) {
        showPopupWarningUnselectPricing.value = true
        contentWarningUnselectPricing.value = `Đội xe ${item.type === 'internal' ? 'Nội bộ' : item?.vendorName || ''}
        đã được phân bổ chuyến hàng. Bạn không thể bỏ chọn đội xe này.`
      }
      return resData?.data?.unSelection
    }
  }
  return false
}
const selectionChangedStep1 = (item: Array<ISearchPriceDetail>) => {
  try {
    if (item && item.length) {
      dataPositionsPricingSelection.value = item[0]
      initDataPrePricing()
      markupCalculate()
    } else {
      dataPositionsPricingSelection.value = null
    }
    refreshRedrawRows()
  } catch (e: any) {}
  dataTablesStep1.value.gridApi.redrawRows()
}

const step = ref(0)

const nextStep = (forceNextStep: boolean = false) => {
  switch (step.value) {
  case 0:
    if (!quoteData.value.prices || !quoteData.value.prices.length) {
      return process.client && $toast().error($t('labels.warningPriceNotFound'))
    }
    if (!dataPositionsPricingStep1.value || !dataPositionsPricingStep1.value.length) {
      return process.client && $toast().error($t('labels.pleaseSelectPrice'))
    }
    dataPositionsPricing.value = $lodash.cloneDeep(dataPositionsPricingStep1.value)
    nextTick(() => {
      editMarkupWhenEdit()
      firstDataRerender(dataTablesStep1.value.gridApi)
    })

    reformatPriceOfflineFee(selectionPriceOfflineFee.value || [])
    if (
      dataCreateQuote.value?.priceOfflineFee &&
      selectionPriceOfflineFee.value &&
      dataCreateQuote.value?.priceOfflineFee.length < selectionPriceOfflineFee.value.length
    ) {
      showOutOfflineFee.value = true
      return null
    }
    break
  case 1:
    if (dataPositionsPricing.value && !forceNextStep) {
      const checkPricingSelection = checkMarkupPricingSelection()
      if (checkPricingSelection) {
        showConfirmWarningMarkup.value = true // có charge markup nhỏ hơn markup cho phép
        return null
      }
    }
    dataCreateQuote.value.informationEditorPricingSelling.pricingRequest = $lodash.ceil(
      dataCreateQuote.value.informationEditorPricingSelling.tempPricingRequest ?? 0,
      -4
    )
    getValuePolicyCharges()
    break
  default:
    return null
  }
  step.value++
}
const previousStep = () => {
  step.value--
  switch (step.value) {
  case 0:
    dataCreateQuote.value.priceOfflineFee = $lodash.cloneDeep(quoteData.value.priceOfflineFee)
    getDefaultSelectionPosition()
    break
  default:
    return null
  }
}

const firstDataRerender = (params: any) => {
  let result: any = null
  params.forEachNode((node: any) => {
    if (node.data) {
      if (!result) {
        result = node
      } else if (result) {
        const oldValue = $lodash.get(result, 'data.pricingEstimate.selling') || 0
        const newValue = $lodash.get(node, 'data.pricingEstimate.selling')
        if (newValue > oldValue) {
          result = node
        }
      }
    }
  })
  if (result) {
    result.setSelected(true)
  }
}
const dataTablesStep1 = ref()

const showPopupEditPricingInformation = ref(false)
const openEditPricingInformation = () => {
  showPopupEditPricingInformation.value = true

  dataEditModelPricingInformation.value.commission = $disableReactive(dataCreateQuote.value.informationEditorPricingSelling.commission)
  dataEditModelPricingInformation.value.duration = $disableReactive(dataCreateQuote.value.informationEditorPricingSelling.duration)
  dataEditModelPricingInformation.value.tempPricingRequest = $disableReactive(dataCreateQuote.value.informationEditorPricingSelling.tempPricingRequest || 0)
}

const dataEditModelPricingInformation = ref({
  tempPricingRequest: null,
  commission: null,
  duration: null
})

const handleSubmitEditPricingInformation = () => {
  dataCreateQuote.value.informationEditorPricingSelling = $disableReactive(dataEditModelPricingInformation.value)
  getDefaultSelectionPosition()
  markupCalculate(true)
  calculatedPriceIncrementLevel()
  showPopupEditPricingInformation.value = false
}

const getDefaultSelectionPosition = () => {
  if (dataTablesStep1.value) {
    const selectedNodes = dataTablesStep1.value.gridApi.getSelectedNodes()
    if (selectedNodes && selectedNodes.length) {
      selectedNodes.forEach((selectedNode: any) => {
        selectedNode.setSelected(false)
      })
    }
  }
}

const markupCalculate = (editMarkup: boolean = false) => {
  const { dataConfig } = quoteData.value
  try {
    if (dataPositionsPricing.value && dataPositionsPricing.value.length) {
      const pricingDetail = dataCreateQuote.value.informationEditorPricingSelling
      dataTablesStep1.value.gridApi.forEachNode((node: any) => {
        const interestRate = node.data.pricingEstimate.total * (dataConfig.monthlyInterest / 100 / 30) * (pricingDetail.duration || 0)
        const markup =
          ((pricingDetail.tempPricingRequest || 0) -
            (pricingDetail.commission || 0) -
            (dataConfig.corporateIncomeTax / 100) * (pricingDetail.commission || 0) -
            interestRate -
            node.data.pricingEstimate.total) /
          node.data.pricingEstimate.total
        const roundMarkup = $lodash.round(markup * 100, 1)
        node.data.pricingEstimate.markup = roundMarkup
        node.data.pricingEstimate.selling = pricingDetail.tempPricingRequest
        node.data.pricingEstimate.profit = $lodash.ceil(node.data.pricingEstimate.total * (roundMarkup / 100), -2)
        if (editMarkup && !node.selected) {
          node.dataConfig = {}
          dataTablesStep1.value.gridApi.redrawRows({ rowNodes: [node] })
        } else {
          refreshTablesStep1()
        }
      })
    }
  } catch (e: any) {}
}

const refreshTablesStep1 = () => {
  if (dataTablesStep1.value) {
    dataTablesStep1.value.gridApi.refreshCells()
  }
}

const refreshRedrawRows = () => {
  if (dataTablesStep1.value) {
    dataTablesStep1.value.gridApi.redrawRows()
  }
}

const reformatPriceOfflineFee = (itemPriceOfflineFee: Array<ISearchPriceDetail>) => {
  const priceOfflineFee = $lodash.cloneDeep(itemPriceOfflineFee)
  if (priceOfflineFee) {
    const items = priceOfflineFee.filter((item) => {
      if (dataPositionsPricing.value && Array.isArray(dataPositionsPricing.value) && dataPositionsPricing.value.length) {
        const itemFilter = dataPositionsPricing.value.filter((itemSelection) => {
          if (itemSelection.type === 'internal') {
            return true
          }
          if (
            itemSelection.priceVendorData?.acceptPriceOfflineFee &&
            Array.isArray(itemSelection.priceVendorData.acceptPriceOfflineFee) &&
            itemSelection.priceVendorData.acceptPriceOfflineFee.length
          ) {
            return itemSelection.priceVendorData.acceptPriceOfflineFee.some((acceptPriceOfflineFee: { [key: string]: any }, index: number) => {
              return !acceptPriceOfflineFee.positions.some((position: { [key: string]: any }, indexPosition: number) => {
                return item.positions[indexPosition].node !== position.node || item.positions[indexPosition].nodeType !== position.nodeType
              })
            })
          }
          return false
        })
        if (itemFilter.length) {
          return true
        }
        return false
      }
      return false
    })

    dataCreateQuote.value.priceOfflineFee = items
  }
}

const _initData = $lodash.debounce((options?: { [key: string]: any }) => {
  const toDate = new Date().getTime()

  if (type.value === 'edit' && quoteData.value && quoteData.value.extendsPrice) {
    if (dataEditQuote.value?.comfirmRouteGGMap || options?.onMounted) {
      quoteData.value.prices = quoteData.value.extendsPrice
    } else {
      quoteData.value.prices = quoteData.value.extendsPriceNotRouteGGMap
    }
  }

  quoteData.value.prices = $lodash.sortBy(quoteData.value.prices, [
    (item: ISearchPriceDetail) => {
      if (item.type === 'internal') {
        return true
      }
    },
    (item: ISearchPriceDetail) => {
      return item.pricingEstimate.total
    },
    (item: ISearchPriceDetail) => {},
    (item: ISearchPriceDetail) => {
      return Math.abs(new Date(item.createdAt).getTime() - toDate)
    }
  ])

  if (dataEditQuote.value && Object.keys(dataEditQuote.value).length) {
    dataCreateQuote.value = dataEditQuote.value
  }

  dataCreateQuote.value.workflow = quoteData.value.quoteRequestData.workflow
  dataCreateQuote.value.positions = quoteData.value.quoteRequestData.positions ? quoteData.value.quoteRequestData.positions : []
  dataCreateQuote.value.transportation = quoteData.value.quoteRequestData.transportation ? quoteData.value.quoteRequestData.transportation : ''
  dataCreateQuote.value.mergeContainer = quoteData.value.quoteRequestData.mergeContainer
  dataCreateQuote.value.headContainer = quoteData.value.quoteRequestData.headContainer
  dataCreateQuote.value.priceOfflineFee = quoteData.value.priceOfflineFee ? $lodash.cloneDeep(quoteData.value.priceOfflineFee) : []
  dataCreateQuote.value.customer = quoteData.value.quoteRequestData.customer
  dataCreateQuote.value.customerName = quoteData.value.quoteRequestData.customerName
  dataCreateQuote.value.contact = quoteData.value.quoteRequestData.contact
  dataCreateQuote.value.contactName = quoteData.value.quoteRequestData.contactName
  dataCreateQuote.value.contactPhone = quoteData.value.quoteRequestData.contactDetail?.phone.phone
  dataCreateQuote.value.contactEmail = quoteData.value.quoteRequestData.contactDetail?.email
  dataCreateQuote.value.contCategory = quoteData.value?.quoteRequestData?.contCategory
  dataCreateQuote.value.vehicleCategory = quoteData.value?.quoteRequestData?.vehicleCategory
  dataCreateQuote.value.vehicleCategoryName = quoteData.value?.quoteRequestData?.vehicleCategoryName
  dataCreateQuote.value.weightCommodity = quoteData.value?.quoteRequestData?.weightCommodity
  dataCreateQuote.value.typeCommodity = quoteData.value?.quoteRequestData?.typeCommodity
  dataCreateQuote.value.goodType = quoteData.value?.quoteRequestData?.goodType
  dataCreateQuote.value.typeDangerous = quoteData.value?.quoteRequestData?.typeDangerous
  dataCreateQuote.value.typeFragileGoods = quoteData.value?.quoteRequestData?.typeFragileGoods
  dataCreateQuote.value.typeReefer = quoteData.value?.quoteRequestData?.typeReefer
  dataCreateQuote.value.dataConfig = quoteData.value?.dataConfig
  dataCreateQuote.value.vehicleCategory = quoteData.value?.vehicleCategory
  dataCreateQuote.value.vehicleCategory = quoteData.value?.vehicleCategoryName
  dataCreateQuote.value.productivity = quoteData.value?.quoteRequestData.productivity
  dataCreateQuote.value.quoteTempSaveId = quoteData.value?.quoteTempSaveId
  dataCreateQuote.value.customerService = quoteData.value?.customerService || {
    id: '',
    name: '',
    phone: ''
  }
  dataCreateQuote.value.abstemious = quoteData.value?.abstemious || {
    id: '',
    name: '',
    phone: ''
  }
  dataCreateQuote.value.cooperatorDetail = quoteData.value?.quoteRequestData?.cooperatorDetail ? quoteData.value?.quoteRequestData?.cooperatorDetail : null
  dataCreateQuote.value.contactDetail = quoteData.value.quoteRequestData.contactDetail ? quoteData.value.quoteRequestData.contactDetail : null
  dataCreateQuote.value.effectiveFromDate = $dayjs().format('YYYY-MM-DD')
  if (type.value === 'edit') {
    dataCreateQuote.value.markupAvailable = dataEditQuote.value?.markupAvailable || false
    dataCreateQuote.value.statusApprovalMarkup = dataEditQuote.value?.statusApprovalMarkup || null
    dataCreateQuote.value.minMarkupConfirm = dataEditQuote.value?.minMarkupConfirm || null
    dataCreateQuote.value.informationEditorPricingSelling = dataEditQuote.value?.informationEditorPricingSelling
    selectionPriceOfflineFee.value = dataEditQuote.value?.priceOfflineFee || []
  } else {
    selectionPriceOfflineFee.value = dataCreateQuote.value?.priceOfflineFee || []
    dataCreateQuote.value.informationEditorPricingSelling.commission = $disableReactive(quoteData.value.dataConfig.commission)
    dataCreateQuote.value.informationEditorPricingSelling.duration = $disableReactive(quoteData.value.dataConfig.duration)
  }
  if (showModalAlert.value) {
    const alerts = quoteData.value.alerts || []

    const alertNotRoute = alerts.find((item: any) => item.alertType === 'notRoute')
    const alertPriceRouteGGMap = alerts.find((item: any) => item.alertType === 'routeGGMap')

    if (alertNotRoute) {
      modals.value.price.show = true
      modals.value.price.label = alertNotRoute.label
      modals.value.price.msgCode = alertNotRoute.msgCode
      modals.value.price.offLineRoutes = alertNotRoute.offLineRoutes?.map((item: string[]) => item.join(' >> ')) || []
    }

    if (alertPriceRouteGGMap) {
      quoteData.value.alerts = []
      modals.value.priceRouteGGMap.show = true
      modals.value.priceRouteGGMap.label = alertPriceRouteGGMap.label
      modals.value.priceRouteGGMap.msgCode = alertPriceRouteGGMap.msgCode
      modals.value.priceRouteGGMap.route = alertPriceRouteGGMap.route?.join(' >> ')
      modals.value.priceRouteGGMap.offLineRoutes =
        alertPriceRouteGGMap.offlineRoutes?.map((item: string[]) => {
          return item.join(' >> ')
        }) || []
    }
  }
  dataCreateQuote.value.comfirmRouteGGMap = quoteData.value?.comfirmRouteGGMap || false
  if (type.value === 'edit') {
    dataEditQuote.value.comfirmRouteGGMap = quoteData.value?.comfirmRouteGGMap || false
  }
}, 100)

onMounted(() => {
  _initData({ onMounted: true })
  nextTick(() => {
    showCostingErrors.value = !!quoteData.value.costingErrors
    showPriceSystemError.value = !!quoteData.value.priceSystemError
  })
})

const getValuePolicyCharges = () => {
  const maxFreeHourNumber = $lodash.maxBy(dataPositionsPricing.value, 'policy.freeHourNumber')
  if (maxFreeHourNumber) {
    dataCreateQuote.value.policy.freeHourNumber = maxFreeHourNumber?.policy?.freeHourNumber || 0
  }

  const maxMoocKeepHourly = $lodash.maxBy(dataPositionsPricing.value, 'policy.moocKeepHourly')
  if (maxMoocKeepHourly) {
    dataCreateQuote.value.policy.moocKeepHourly = maxMoocKeepHourly?.policy?.moocKeepHourly || 0
  }

  const maxMoocKeepOvernight = $lodash.maxBy(dataPositionsPricing.value, 'policy.moocKeepOvernight')
  if (maxMoocKeepOvernight) {
    dataCreateQuote.value.policy.moocKeepOvernight = maxMoocKeepOvernight?.policy?.moocKeepOvernight || 0
  }

  const maxCalculatedByHourNextDay = $lodash.maxBy(dataPositionsPricing.value, 'policy.calculatedByHourNextDay')
  if (maxCalculatedByHourNextDay) {
    dataCreateQuote.value.policy.calculatedByHourNextDay = maxCalculatedByHourNextDay?.policy?.calculatedByHourNextDay || ''
  }

  const maxMoocKeepLongTerm = $lodash.maxBy(dataPositionsPricing.value, 'policy.moocKeepLongTerm')
  if (maxMoocKeepLongTerm) {
    dataCreateQuote.value.policy.moocKeepLongTerm = maxMoocKeepLongTerm?.policy?.moocKeepLongTerm || 0
  }

  const maxCalculatedFromEvening = $lodash.maxBy(dataPositionsPricing.value, 'policy.calculatedFromEvening')
  if (maxCalculatedFromEvening) {
    dataCreateQuote.value.policy.calculatedFromEvening = maxCalculatedFromEvening?.policy?.calculatedFromEvening || 0
  }

  const maxTowingContainerSunday = $lodash.maxBy(dataPositionsPricing.value, 'policy.towingContainerSunday')
  if (maxTowingContainerSunday) {
    dataCreateQuote.value.policy.towingContainerSunday = maxTowingContainerSunday?.policy?.towingContainerSunday || 0
  }
  const maxTowingContainerHoliday = $lodash.maxBy(dataPositionsPricing.value, 'policy.towingContainerHoliday')
  if (maxTowingContainerHoliday) {
    dataCreateQuote.value.policy.towingContainerHoliday = maxTowingContainerHoliday?.policy?.towingContainerHoliday || 0
  }
  const maxReeferPluginChargesGenerator = $lodash.maxBy(dataPositionsPricing.value, 'policy.reeferPluginChargesGenerator')
  if (maxReeferPluginChargesGenerator) {
    dataCreateQuote.value.policy.reeferPluginChargesGenerator = maxReeferPluginChargesGenerator?.policy?.reeferPluginChargesGenerator || 0
  }
}

const handleCreateQuoteRequest = async (options: { [key: string]: any } = {}) => {
  loading.value = true
  try {
    dataCreateQuote.value.charges = reformatCharges($lodash.cloneDeep(dataPositionsPricing.value ? dataPositionsPricing.value : []))
    dataCreateQuote.value.priceOfflineFee = reformatCharges($lodash.cloneDeep(dataCreateQuote.value.priceOfflineFee ?? []))
    dataCreateQuote.value.quoteRequestId = quoteRequestId.value
    const body = {
      ...$lodash.pick(
        dataCreateQuote.value,
        'quoteRequestId',
        'informationEditorPricingSelling',
        'workflow',
        'contact',
        'exceptCompensationCost',
        'compensationCost',
        'groupEmail',
        'abstemious',
        'customerService',
        'transportation',
        'positions',
        'customer',
        'quoteTempSaveId',
        'effectiveToDate',
        'effectiveFromDate',
        'comfirmRouteGGMap'
      ),
      sendEmail: !!options.sendEmail,
      priceOfflineFeeIds: $lodash.map(dataCreateQuote.value.priceOfflineFee, '_id'),
      chargeIds: $lodash.map(dataCreateQuote.value.charges, '_id')
    }

    const api = $urlPartner.quote.create
    const data: any = await $api(api, { body })
    const resData = data?.data?.value

    if (resData && resData.success) {
      if (resData.success) {
        process.client && $toast().success($t('labels.createQuoteSuccess'))
        return resData.data
      }
    }
    loading.value = false
    return false
  } catch (e: any) {
    loading.value = false
    return false
  }
}

const reformatCharges = (charges: Array<ISearchPriceDetail>) => {
  // reformat charges
  charges.forEach((charge: ISearchPriceDetail, index: number) => {
    charges[index].positions = modifyPositionRequest(charge.positions)
  })
  return charges
}

const modifyPositionRequest = (positions: Array<{ [key: string]: any }>) => {
  // reformat positions
  return positions.map((position) => {
    const { fullNameNode, locationName, nodeLocationName, index, lat, lng, node, nodeType, nodeTypeName, _id, quoteEqual, tasks, nodeData } = position
    return {
      fullNameNode,
      locationName,
      nodeLocationName,
      index,
      lat,
      lng,
      node,
      nodeType,
      nodeTypeName,
      _id,
      quoteEqual,
      tasks,
      nodeData
    }
  })
}

const checkMarkupPricingSelection = (options?: { [key: string]: any }): boolean => {
  // check markup nhỏ hơn markup cho phép
  const markupCheck =
    type.value === 'edit' && dataCreateQuote.value.statusApprovalMarkup === 1
      ? dataCreateQuote.value.minMarkupConfirm || 0
      : dataCreateQuote.value?.dataConfig?.markup || 0

  let result = false
  if (dataTablesStep1.value) {
    dataTablesStep1.value.gridApi.forEachNode((node: any) => {
      node.dataConfig = dataCreateQuote.value?.dataConfig
      if (!result) {
        if ((node.data.pricingEstimate.markup || 0) < (markupCheck || 0)) {
          result = true
        }
      }
    })
  }

  if (result && options?.checkPermission) {
    const check = checkPermission(layoutPermissions.partner_confirm_status_markup)
    if (check) {
      result = false
    }
  }
  return result
}

const comfirmRouteGGMap = () => {
  quoteData.value.comfirmRouteGGMap = true
  dataCreateQuote.value.comfirmRouteGGMap = true
  if (type.value === 'edit') {
    dataEditQuote.value.comfirmRouteGGMap = true
  }
  modals.value.priceRouteGGMap.show = false
  quoteData.value.alerts = []
  // _initData()
}
const rejectRouteGGMap = () => {
  quoteData.value.comfirmRouteGGMap = false
  dataCreateQuote.value.comfirmRouteGGMap = false
  if (type.value === 'edit') {
    dataEditQuote.value.comfirmRouteGGMap = false
  }
  modals.value.priceRouteGGMap.show = false
  quoteData.value.prices = quoteData.value.pricesNotRouteGGMap || []
  quoteData.value.priceOfflineFee = quoteData.value.priceOfflineFeeNotRouteGGMap || []
  quoteData.value.alerts = []

  const internal = quoteData.value.prices.find((item: any) => item.type === 'internal')

  if (!internal) {
    quoteData.value.alerts = [
      {
        alertType: 'notRoute',
        label: 'Hệ thống không thể tính toán giá nội bộ do thiếu thông tin tuyến.'
      }
    ]
    const alertNotRoute = quoteData.value.alerts?.find((item: any) => item.alertType === 'notRoute')
    modals.value.price.show = true
    modals.value.price.label = alertNotRoute.label
  }

  _initData()
}

const loading = ref(false)
defineExpose({
  step,
  loading,
  nextStep,
  previousStep,
  handleCreateQuoteRequest,
  dataCreateQuote,
  dataPositionsPricing,
  reformatCharges,
  checkMarkupPricingSelection
})

const dataTables = ref()

// onBeforeMount(() => {
//   const toDate = new Date().getTime()
//   quoteData.value.prices = $lodash.sortBy(quoteData.value.prices, [
//     (item: ISearchPriceDetail) => {
//       if (item.type === 'internal') {
//         return true
//       }
//     },
//     (item: ISearchPriceDetail) => {
//       return item.pricingEstimate.total
//     },
//     (item: ISearchPriceDetail) => {},
//     (item: ISearchPriceDetail) => {
//       return Math.abs(new Date(item.createdAt).getTime() - toDate)
//     }
//   ])
//   if (quoteData.value && quoteData.value.extendsPrice) {
//     quoteData.value.extendsPrice.forEach((itemExtend: ISearchPriceDetail) => {
//       if (quoteData.value.prices) {
//         quoteData.value.prices.push(itemExtend)
//       }
//     })
//   }
//   if (dataEditQuote.value && Object.keys(dataEditQuote.value).length) {
//     dataCreateQuote.value = dataEditQuote.value
//   }
// })

const firstDataRerenderDataTable = (params: any) => {
  if (type.value === 'edit') {
    params &&
      params.api.forEachNode((node: any) => {
        const findItemExtend =
          quoteData.value.extendsPrice &&
          quoteData.value.extendsPrice.find((itemExtend: ISearchPriceDetail) => {
            return itemExtend._id === node.data._id
          })
        if (!findItemExtend) {
          node.setSelected(true)
        }
      })
  }
}

const editMarkupWhenEdit = () => {
  if (type.value === 'edit') {
    // markupCalculate()
    // refreshRedrawRows()
  }
}

const selectionPriceOfflineFee = ref<Array<ISearchPriceDetail>>()

const viewOfflineFee = ref() // biến chứa component view offline dee
const selectTheLeftLane = () => {
  // mở model chọn phí trái tuyến
  viewOfflineFee && viewOfflineFee.value.openViewPriceOfflineFee()
}

const showOutOfflineFee = ref(false) // show khi thiếu giá mua của trái tuyến
const confirmOutOfflineFee = () => {
  // vẫn qua được bước 1 của tạo báo giá
  step.value = 1
  showOutOfflineFee.value = false
}

const contentConfirmMarkup = computed(() => {
  //  label confirm markup
  if (checkPermission(layoutPermissions.partner_confirm_status_markup)) {
    return `Giá trị markup tương ứng với các đội xe nhỏ hơn giá trị markup cho phép ${dataCreateQuote.value?.dataConfig?.markup || 0}%. Bạn có muốn tiếp tục?`
  } else {
    return `Giá trị markup tương ứng với các đội xe nhỏ hơn giá trị markup cho phép ${
      dataCreateQuote.value?.dataConfig?.markup || 0
    }%. Hệ thống cần phê duyệt từ bộ phận quản lý sau khi báo giá được tạo. Bạn có muốn tiếp tục?`
  }
})

const handelConfirmWarningMarkup = () => {
  showConfirmWarningMarkup.value = false
  nextStep(true)
}
</script>

<style scoped>
.table-step-1 :deep(.ag-checkbox-input-wrapper::after) {
  content: '\f126';
}

.table-step-1 :deep(.ag-cell-wrapper) {
  justify-content: center;
}

.table-step-1 :deep(.ag-checked::after) {
  content: '\f127';
}
</style>
